<div class="flex size-full flex-row items-end gap-2">
  @for (item of [].constructor(numSteps()); track $index) {
    <div class="max-w-1/4 flex-1">
      @if ($index < numCompleted()) {
        <img src="assets/woordkr8/sprites/light-bulb-green.png" class="w-full object-contain" />
      } @else if ($index === numCompleted()) {
        <img src="assets/woordkr8/sprites/light-bulb-orange.png" class="w-full object-contain" />
      } @else {
        <img src="assets/woordkr8/sprites/light-bulb-off.png" class="w-full object-contain" />
      }
    </div>
  }
</div>
